/**
 * Use Case: Fetch Reward Catalog
 * Business logic for fetching reward catalog data.
 */

import type {
  VoucherListQuery,
  VoucherListResult,
} from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch voucher list with pagination
 */
export const FetchVoucherListUseCase = async (
  query?: VoucherListQuery
): Promise<VoucherListResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchVoucherList(query);
};
